import {gql} from "@apollo/client";

export const GET_BRANCHES = gql`
query($input: BranchFilter!){
    branches(input: $input) {
        branches{
            _id
            branchname
            postcode
            metadata
        }
        totalCount
        currentPage
        totalPages
    }
}
`;

export const GetBranchObject = gql`
    query{
        getBranchProperty {
        response
        }
    }
`;

export const getSingleBranch = gql`
query($id: String!){
    branch(_id: $id) {
      _id
      branchname
      postcode
      metadata
    }
}
`;